// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"8120c46c","211":"634ffbb4","393":"a7543280","415":"e9df0c09","458":"1c96d44b","479":"9c3a9ed2","633":"4c379922","644":"9931dc13","646":"7435c49d","667":"c17dda5e","831":"c8d1417d","967":"03088448"}[chunkId] + ".chunk.js";
};